const { Chargebee } = window as any;

const publishableKey = process.env['NX_CHARGEBEE_PUBLISHABLE_KEY'];
const site = process.env['NX_CHARGEBEE_SITE_ID'];

if (Chargebee) {
  Chargebee.init({
    publishableKey,
    site,
  });
}

export { Chargebee };
